import { shareColumnsExtend, shareFormColumnsExtend } from '../share';

const entityColumns = {
  id: {
    model_name: 'Walk::HebaParticipationRecord',
    column_type: 'id',
  },
  created_at: {
    model_name: 'Walk::HebaParticipationRecord',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'Walk::HebaParticipationRecord',
    column_type: 'datetime',
  },
  month: {
    model_name: 'Walk::HebaParticipationRecord',
    column_type: 'string',
  },
  target: {
    model_name: 'Walk::HebaParticipationRecord',
    column_type: 'integer',
  },
  health_points: {
    model_name: 'Walk::HebaParticipationRecord',
    column_type: 'integer',
  },
  reward_state: {
    model_name: 'Walk::HebaParticipationRecord',
    column_type: 'enum',
  },
  state: {
    model_name: 'Walk::HebaParticipationRecord',
    column_type: 'enum',
  },
  reward_cashback: {
    model_name: 'Walk::HebaParticipationRecord',
    column_type: 'string',
  },
  miapay_wallet_holder: {
    model_name: 'Walk::HebaParticipationRecord',
    column_type: 'belongs_to',
    extra: {
      association_name: 'miapay_wallet_holder',
      model_name: 'Miapay::WalletHolder',
      foreign_key: 'miapay_wallet_holder_id',
    },
  },
  miapay_wallet_holder_id: {
    model_name: 'Walk::HebaParticipationRecord',
    column_type: 'belongs_to',
    extra: {
      association_name: 'miapay_wallet_holder',
      model_name: 'Miapay::WalletHolder',
      foreign_key: 'miapay_wallet_holder_id',
    },
  },
  step_by_month: {
    model_name: 'Walk::HebaParticipationRecord',
    column_type: 'string',
  },
  kilometers_distance_by_month: {
    model_name: 'Walk::HebaParticipationRecord',
    column_type: 'string',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
